module.exports = __webpack_public_path__ + "static/media/epcoss.3099304f.svg";